import React, { useState, useEffect } from "react";
import { UrlProvider } from "../../../utils/UrlProvider";
import PropTypes from "prop-types";
import SectionHeading from "../../common/headings/SectionHeading";

const Heading = ({ heading, heading_image, heading_color, arrow_image }) => {
  const [isFocus, setIsFocus] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const componentPosition =
        document.getElementById("know_more_heading").offsetTop;
      const componentHeight =
        document.getElementById("know_more_heading").offsetHeight;

      if (
        scrollPosition + window.innerHeight > componentPosition &&
        scrollPosition < componentPosition + componentHeight
      ) {
        setIsFocus(true);
      } else {
        setIsFocus(false);
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div
      id="know_more_heading"
      className="text-center font-KrubMedium relative md:w-none w-[90%] mx-auto"
    >
      <SectionHeading lable={heading} lable_color={heading_color} />
      {/* <img
        src={UrlProvider(heading_image?.url)}
        alt={""}
        className={`ml-[15%] md:ml-[52%] h-[6vw] md:h-[0.5vw] md:w-[33%] w-[70%] transition-all duration-1000 ${
          isFocus
            ? "opacity-100 translate-x-0 width-[33%]"
            : " opacity-0 -translate-x-[5vw] w-0"
        } `}
      /> */}
      {/* <img
        src={UrlProvider(arrow_image?.url)}
        alt={arrow_image?.alternativeText}
        className={`absolute -bottom-[8vw] md:-bottom-[6vw] left-[72vw] md:left-[60vw] transition-all duration-[2000ms] -rotate-46 md:rotate-0 ${
          isFocus
            ? "opacity-100 translate-x-[3vw] w-[14vw] md:w-[5vw]"
            : "opacity-0 translate-x-[1vw] w-0"
        }`}
      /> */}
    </div>
  );
};

Heading.propTypes = {
  heading: PropTypes.string,
  heading_image: PropTypes.object,
  heading_color: PropTypes.string,
  arrow_image: PropTypes.object,
};

export default Heading;
